import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getMyLikedServices } from "apis";
import { Loading } from "components";
import { ServiceDTO } from "types/DTOs/service/service.dto";

const LikedServicesComponent = () => {
    const navigate = useNavigate();
    const [services, setServices] = useState<ServiceDTO[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getMyLikedServices()
            .then(res => setServices(res.data.data ?? []))
            .catch(() => {})
            .finally(() => setIsLoading(false));
    }, []);

    if (isLoading) return <Loading />;

    if (services.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center py-16 gap-3">
                <span className="text-4xl">💜</span>
                <p className="text-sm font-semibold text-achromatic-700">좋아요한 서비스가 없습니다</p>
                <p className="text-xs text-achromatic-400">마음에 드는 서비스에 ❤️를 눌러보세요</p>
                <button
                    onClick={() => navigate("/service")}
                    className="mt-2 px-5 py-2.5 bg-primary-500 text-white rounded-xl text-sm font-bold hover:bg-primary-600 transition-colors"
                >
                    서비스 둘러보기
                </button>
            </div>
        );
    }

    return (
        <div className="p-4 flex flex-col gap-3">
            <p className="text-[11px] text-achromatic-400 font-medium">{services.length}개의 서비스</p>
            {services.map(service => {
                const thumb = service.images?.[0];
                const imgSrc = thumb
                    ? (thumb.startsWith('http') ? thumb : `${process.env.REACT_APP_API_URL}/${thumb}`)
                    : null;
                return (
                    <div
                        key={service.id}
                        onClick={() => navigate(`/service/${service.id}`)}
                        className="flex gap-3 p-3 bg-achromatic-50 rounded-xl cursor-pointer hover:bg-achromatic-100 transition-colors"
                    >
                        {imgSrc ? (
                            <img src={imgSrc} alt="" className="w-16 h-16 rounded-lg object-cover flex-shrink-0" />
                        ) : (
                            <div className="w-16 h-16 rounded-lg bg-achromatic-200 flex items-center justify-center text-2xl flex-shrink-0">
                                📦
                            </div>
                        )}
                        <div className="flex-1 min-w-0 flex flex-col justify-center">
                            <div className="flex items-center gap-2 mb-0.5">
                                <span className="text-[11px] font-semibold px-1.5 py-0.5 rounded bg-primary-50 text-primary-600">
                                    {service.category}
                                </span>
                            </div>
                            <h3 className="text-[14px] font-bold text-achromatic-900 truncate">{service.title}</h3>
                            <div className="flex items-center gap-2 mt-0.5">
                                <span className="text-[13px] font-bold text-primary-500">{service.price?.toLocaleString()}원</span>
                                <span className="text-[11px] text-achromatic-400">⏱ {service.durationMinutes}분</span>
                            </div>
                        </div>
                        <div className="flex items-center text-red-400 text-lg">❤️</div>
                    </div>
                );
            })}
        </div>
    );
};

export default LikedServicesComponent;
